import type { LearningConsentState } from 'types/learningConsent';
import { useLearningConsentContext } from 'schools/parashari/contexts/LearningConsentContext';

export type { LearningConsentState };

export function useLearningConsent(): LearningConsentState {
  return useLearningConsentContext();
}
